"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsCountFieldLogic = void 0;
const isNil_1 = __importDefault(require("lodash-es/isNil"));
const comparisons_1 = require("../../comparisons/comparisons");
const google_sheet_1 = require("../../utils/google-sheet");
const intl_1 = require("../../locale/intl");
const comments_count_fieldtype_1 = require("../../safe-field-value/numder-fields/comments-count-field/comments-count.fieldtype");
const texts_1 = require("../../texts");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
class CommentsCountFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "commentscountfield";
        this.label = (0, intl_1.$t)(texts_1.commentsCountFieldText.open_comments);
        this.icon = "comment-2";
        this.placeholder = (0, intl_1.$t)(texts_1.commentsCountFieldText.enter_number_here);
        this.searchSynonyms = [];
        this.fieldDisabledMessage = (0, intl_1.$t)(texts_1.commentsCountFieldText.this_is_a_system_field);
        this.uniqueByApplication = true;
        this.fieldValueGetter = new comments_count_fieldtype_1.CommentsCountFieldValueGetter();
        this.clipboardPasteRules = {};
        this.comparisons = {
            is_equal_to: comparisons_1.isEqualTo,
            is_not_equal_to: comparisons_1.isNotEqualTo,
            // @ts-expect-error: Need to resolve
            is_greater_than: comparisons_1.isGreaterThan,
            // @ts-expect-error: Need to resolve
            is_less_than: comparisons_1.isLessThanAndNotEmpty,
            // @ts-expect-error: Need to resolve
            is_equal_or_greater_than: comparisons_1.isEqualOrGreaterThan,
            // @ts-expect-error: Need to resolve
            is_equal_or_less_than: comparisons_1.isEqualOrLessThanAndNotEmpty,
            // @ts-expect-error: Need to resolve
            is_empty: comparisons_1.isZero,
            // @ts-expect-error: Need to resolve
            is_not_empty: comparisons_1.isGreatThanZero,
        };
    }
    get validators() {
        return {};
    }
    valueToString(fieldValue) {
        return (0, isNil_1.default)(fieldValue) ? "" : fieldValue.toString();
    }
    valueToGoogleSheet(fieldValue) {
        return (0, google_sheet_1.makeRowDataValues)(fieldValue, "numberValue");
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        return {
            t: "n",
            v: this.valueToExport(fieldValue, field, userPreferences, _record),
        };
    }
    getEmptyValue() {
        return 0;
    }
    getInitialFieldValue(_startValue, _field, _userPreferences) {
        return this.getEmptyValue();
    }
    showSystemLockIcon() {
        return false;
    }
    getGridColumnSettings() {
        return {
            icon: "comment-grid",
            showLabel: false,
            minWidth: 54,
            defaultWidth: 54,
            resizable: true,
            contentAlignment: "centered",
        };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            allowAddRecordToGroup: false,
        };
    }
    canChangeValue(field, fromValue, toValue) {
        return this.isValueEqual(fromValue, toValue, field);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
}
exports.CommentsCountFieldLogic = CommentsCountFieldLogic;
